import DTSTAMP from './DTSTAMP'

/**
 * DTSTART property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.2.4
 */
export default class DTSTART extends DTSTAMP {
  static propName = 'DTSTART'
}



/** WEBPACK FOOTER **
 ** ./src/properties/DTSTART.js
 **/